import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { materialThickness as defaultOptions } from 'pu-data/SelectOptions';
import { materialThickness as tooltip } from 'pu-data/Tooltips';
import SelectComponent from './SelectComponent';
import TextComponent from './TextComponent';

const MaterialThickness = ({
  options, parameters, onChangeParameter, groupName, className, label, required,
}) => {
  const [allowCustomThickness, setAllowCustomThickness] = useState(false);
  const [showCustomThickness, setShowCustomThickness] = useState(false);
  const [selected, setSelected] = useState();
  const name = 'material_thickness';

  const onChangeSelect = e => {
    const value = e.target.value
    if (value === 'Other') {
      setShowCustomThickness(true)
    } else {
      setShowCustomThickness(false)
      onChangeParameter(name, value)
    }
    setSelected(value)
  }

  const onChange = e => {
    onChangeParameter(name, e.target.value)
  }

  useEffect(() => {
    const defaultValue = parameters[name];
    setSelected(defaultValue)
    if (options.find(o => o.value == 'Other')) {
      setAllowCustomThickness(true)
    }

    if (!defaultOptions.find(o => o.value == defaultValue) || defaultValue == 'Other') {
      setSelected('Other')
      setShowCustomThickness(true)
    }
  }, [])

  useEffect(() => {
    const value = parameters[name];
    if (value) {
      setSelected(value)
    }
  }, [parameters])

  const value = parameters[name];

  return (
    <div className="clearfix">
      <div className="row quote-size">
        <div className={`${allowCustomThickness ? 'col-6' : 'col-12'}`}>
          <SelectComponent
            label={label}
            required={required}
            name={`${showCustomThickness ? 'custom_material_thickness' : name}`}
            onChange={onChangeSelect}
            options={options}
            tooltip={tooltip}
            selected={selected}
            groupName={groupName}
            className={classnames('material-thickness', className)} />
        </div>
        <div className={`${allowCustomThickness ? 'col-6' : 'col-12'}`}>
          {showCustomThickness ? <TextComponent
            name={name}
            value={value === 'Other' ? null : value}
            label={'Custom thickness'}
            required={required}
            placeholder={'board thickness (in)'}
            groupName={groupName}
            onChange={onChange}
            tooltip={tooltip}
            className={classnames('material-thickness', className)} /> : null}
        </div>
      </div>
    </div>
  );
};

MaterialThickness.defaultProps = {
  options: defaultOptions,
  label: 'Board <br class="d-none d-lg-block d-xl-none" /> Thickness',
};

export default MaterialThickness;
